module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order_for":"Order for","order_for_change":"Change","order_for_is_loading":"loading"},"de":{"order_for":"Bestellung für","order_for_change":"Ändern","order_for_is_loading":"wird geladen"}}')
  delete Component.options._Ctor
}
